<ion-content>
	<ion-row class="ion-justify-content-center padding-auth" role="region" aria-label="Centered content row">
		<ion-col *ngIf="!loading">
			<ion-row class="ion-justify-content-center">
				<ion-img class="ion-margin" src="/assets/icon/icon-maintenance.svg" alt=""></ion-img>
				<p class="bold font-18 align-center">
					{{'maintenance_page.title' | translate}}<br />
					{{'maintenance_page.sub_title' | translate}}
				</p>
				<p class="font-14 align-center">{{'maintenance_page.description' | translate}}</p>
			</ion-row>
			<ion-row role="region" aria-label="Content section">
				<ion-button (click)="reload()" class="ion-no-margin"> {{ 'maintenance_page.reload' | translate }} </ion-button>
			</ion-row>
		</ion-col>
		<ion-row *ngIf="loading" class="ion-justify-content-center" role="region" aria-label="Loading content">
			<ion-spinner></ion-spinner>
		</ion-row>
	</ion-row>
</ion-content>
